import { render, staticRenderFns } from "./FrontierTourList.vue?vue&type=template&id=3d91c99e&scoped=true"
import script from "./FrontierTourList.vue?vue&type=script&lang=js"
export * from "./FrontierTourList.vue?vue&type=script&lang=js"
import style0 from "./FrontierTourList.vue?vue&type=style&index=0&id=3d91c99e&prod&lang=scss&scoped=true"
import style1 from "./FrontierTourList.vue?vue&type=style&index=1&id=3d91c99e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d91c99e",
  null
  
)

export default component.exports